/**
 * Jetton Configuration
 * Defines available jettons for different networks (mainnet/testnet)
 */

export interface JettonConfig {
    symbol: string;
    name: string;
    address: {
        mainnet: string;
        testnet: string;
    };
    icon: string;
}

/**
 * Available jettons configuration
 * Add new jettons here with their mainnet and testnet addresses
 */
export const JETTONS_CONFIG: JettonConfig[] = [
    {
        symbol: "TON",
        name: "Toncoin",
        address: {
            mainnet: "TON", // Special marker for native TON
            testnet: "TON" // Special marker for native TON
        },
        icon: "https://ton.org/download/ton_symbol.png"
    },
    {
        symbol: "TMC",
        name: "TamaMon",
        address: {
            mainnet: "0:daf926cbf44ae6aaf25db51434ea8eba91ee532656daf8f9e61c2153cba6d90f",
            testnet: "0:daf926cbf44ae6aaf25db51434ea8eba91ee532656daf8f9e61c2153cba6d90f" // Same for testnet
        },
        icon: "https://i.imgur.com/BS46Pns.png"
    },
    {
        symbol: "USDT",
        name: "Tether USD",
        address: {
            mainnet: "EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs",
            testnet: "EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs" // Same for testnet
        },
        icon: "https://cache.tonapi.io/imgproxy/T3PB4s7oprNVaJkwqbGg54nexKE0zzKhcrPv8jcWYzU/rs:fill:200:200:1/g:no/aHR0cHM6Ly90ZXRoZXIudG8vaW1hZ2VzL2xvZ29DaXJjbGUucG5n.webp"
    },
    {
        symbol: "ODDB",
        name: "OASIS DECENTRALIZED DATABASE",
        address: {
            mainnet: "0:97b5ba103e3c189cc82cfa4ddc68b9b87a55cb6eb1cee49bf424e295eb5ec73b",
            testnet: "0:97b5ba103e3c189cc82cfa4ddc68b9b87a55cb6eb1cee49bf424e295eb5ec73b" // Same for testnet
        },
        icon: "https://tan-bitter-marmoset-938.mypinata.cloud/ipfs/bafkreiecr3uoquah6apykv7fu62ypvewdotyqbfroxbcqul7qnzvv4geta"
    }
];

/**
 * Get jetton address for current network
 */
export function getJettonAddress(jettonConfig: JettonConfig, network: "mainnet" | "testnet"): string {
    return jettonConfig.address[network];
}

/**
 * Get all jettons for current network
 * @param network - mainnet or testnet
 * @param includeNativeTON - whether to include native TON (default: false, excluded for pool trading)
 */
export function getJettonsForNetwork(network: "mainnet" | "testnet", includeNativeTON: boolean = false) {
    return JETTONS_CONFIG
        .filter(jetton => includeNativeTON || jetton.symbol !== "TON") // Exclude native TON from pool by default
        .map(jetton => ({
            symbol: jetton.symbol,
            name: jetton.name,
            address: getJettonAddress(jetton, network),
            icon: jetton.icon
        }));
}
